
import { defineComponent, computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import RegisterFlow from '@/components/registerTeam/RegisterFlow.vue'
import useValidateForAccess from '@/Hooks/useValidateForAccess'
import AppInfo from '@/util/AppInfo'

export default defineComponent({
  name: 'PasswordChangeCompletePage',
  setup() {
    const { t } = useI18n()
    onMounted(() => {
      useValidateForAccess('PasswordChangeStore', ['tokenId'], 'ErrorPage')
    })
    const fluxLoginUrl = computed(() => {
      if (AppInfo.isSmartPhone) {
        return `${process.env.VUE_APP_FLUX_LOGIN_PAGE_BASE_URL}/flsp/index.html#/login`
      }
      return `${process.env.VUE_APP_FLUX_LOGIN_PAGE_BASE_URL}/fl/index.html#/login`
    })
    return {
      fluxLoginUrl,
      t,
    }
  },
  components: {
    RegisterFlow,
  },
})
